import { makeStyles } from '@material-ui/core/styles';
import { TextColors } from '@/utils/constants';

const aspectRatio = {
  left: {
    '&.ar-20-80': { width: '20%' },
    '&.ar-25-75': { width: '25%' },
    '&.ar-30-70': { width: '30%' },
    '&.ar-35-65': { width: '35%' },
    '&.ar-40-60': { width: '40%' },
    '&.ar-45-55': { width: '45%' },
    '&.ar-50-50': { width: '50%' },
    '&.ar-55-45': { width: '55%' },
    '&.ar-60-40': { width: '60%' },
    '&.ar-65-35': { width: '65%' },
    '&.ar-70-30': { width: '70%' },
    '&.ar-75-25': { width: '75%' },
    '&.ar-80-20': { width: '80%' },
  },
  right: {
    '&.ar-20-80': { width: '80%' },
    '&.ar-25-75': { width: '75%' },
    '&.ar-30-70': { width: '70%' },
    '&.ar-35-65': { width: '65%' },
    '&.ar-40-60': { width: '60%' },
    '&.ar-45-55': { width: '55%' },
    '&.ar-50-50': { width: '50%' },
    '&.ar-55-45': { width: '45%' },
    '&.ar-60-40': { width: '40%' },
    '&.ar-65-35': { width: '35%' },
    '&.ar-70-30': { width: '30%' },
    '&.ar-75-25': { width: '25%' },
    '&.ar-80-20': { width: '20%' },
  },
};

const darkTheme = {
  title: {
    color: TextColors.light,
  },
};

const lightTheme = {
  title: {
    color: TextColors.dark,
  },
};

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      width: '100%',
    },
    title: {
      '&.dark-theme': darkTheme.title,
      '&.light-theme': lightTheme.title,
      '&.MuiTypography-root': {
        marginBottom: '12px',
      },
    },

    columns: {
      display: 'flex',

      '& .column': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        alignContent: 'flex-start',

        '& > *': {
          width: '100%',
        },
      },

      [muiTheme.breakpoints.down('sm')]: {
        marginBottom: muiTheme.spacing(3),
      },

      [muiTheme.breakpoints.down('sm')]: {
        flexDirection: 'column',
      },
    },

    leftColumn: {
      width: '100%',

      [muiTheme.breakpoints.up('md')]: {
        ...aspectRatio.left,
        flexGrow: 1,
      },

      '&:not(:last-child)': {
        [muiTheme.breakpoints.down('sm')]: {
          marginBottom: muiTheme.spacing(3),
        },

        [muiTheme.breakpoints.up('md')]: {
          paddingRight: muiTheme.spacing(5),
        },
      },
    },

    rightColumn: {
      width: '100%',

      [muiTheme.breakpoints.up('md')]: {
        ...aspectRatio.right,
        flexGrow: 1,
      },

      '&:not(:first-child)': {
        [muiTheme.breakpoints.up('md')]: {
          paddingLeft: muiTheme.spacing(5),
        },
      },
    },
  }),
  { name: 'GenTwoColumnContent' },
);

export default useStyles;
